export default {"src":"/_next/static/media/apiSecret.48cb7ea2.svg","height":18,"width":20};